// Période d'un RDV multi-jours (« jeu. 15 → ven. 16 oct. »), null si RDV sur une seule journée.
export function apptPeriod(start, end) {
  if (!start || !end) return null;
  const s = new Date(start);
  const e = new Date(end);
  if (e.getHours() === 0 && e.getMinutes() === 0) e.setDate(e.getDate() - 1);
  const sd = new Date(s.getFullYear(), s.getMonth(), s.getDate());
  const ed = new Date(e.getFullYear(), e.getMonth(), e.getDate());
  if (ed <= sd) return null;
  const wd = (d) => d.toLocaleDateString("fr-FR", { weekday: "short" });
  const mon = (d) => d.toLocaleDateString("fr-FR", { month: "short" });
  const sameMonth = sd.getMonth() === ed.getMonth() && sd.getFullYear() === ed.getFullYear();
  return `${wd(sd)} ${sd.getDate()}${sameMonth ? "" : ` ${mon(sd)}`} → ${wd(ed)} ${ed.getDate()} ${mon(ed)}`;
}
